import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import AddLocationLayer from "../../components/Locations/AddLocationLayer";




const AddLocationPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb  title="Add Location" />

        {/* Add Project Layer */}
        <AddLocationLayer />

      </MasterLayout>
    </>
  );
};

export default AddLocationPage;
